export default (clientReports) => clientReports.slice().sort((a, b) => new Date(b.scoringDate) - new Date(a.scoringDate));
